import { ChangeDetectionStrategy, Component, computed, input, type InputSignal, type Signal } from '@angular/core';
import { UiInlineMessageLive } from '../../types/ui-inline-message-live.type';
import { UiStateTone } from '../../types/ui-state-tone.type';

@Component({
  selector: 'ui-inline-message',
  imports: [],
  templateUrl: './ui-inline-message.component.html',
  styleUrl: './ui-inline-message.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiInlineMessageComponent {
  public readonly text: InputSignal<string> = input.required<string>();
  public readonly tone: InputSignal<UiStateTone> = input<UiStateTone>('neutral');
  public readonly iconLabel: InputSignal<string> = input<string>('i');
  public readonly ariaLive: InputSignal<UiInlineMessageLive> = input<UiInlineMessageLive>('off');

  protected readonly isNeutral: Signal<boolean> = computed((): boolean => this.tone() === 'neutral');
  protected readonly isInfo: Signal<boolean> = computed((): boolean => this.tone() === 'info');
  protected readonly isSuccess: Signal<boolean> = computed((): boolean => this.tone() === 'success');
  protected readonly isWarning: Signal<boolean> = computed((): boolean => this.tone() === 'warning');
  protected readonly isDanger: Signal<boolean> = computed((): boolean => this.tone() === 'danger');
}
